import { FunctionComponent } from "react";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";
import { ConfirmTransferScreenProps } from "../useConfirmTransfer";
import Spacing from "../../../layout/spacing";
import { TitleLarge } from "../../../components/font";
import { FormContainer } from "../../destination-account/screens/styles";
import { Autocomplete, Button, SearchableDropdown, TextField } from "@manifesthhqinc/ui-library";
import HeadingContainer from "../../../layout/heading-container";

const MailingAddress: FunctionComponent<ConfirmTransferScreenProps> = (props: ConfirmTransferScreenProps) => {
  const {
    onClickContinue,
    statesList,
    validateField,
    validation,
    onLoadAddress,
    updateAutofillAddress,
    mailingAddress,
    setMailingAddress,
  } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="confirm-transfer-screen-mailingAdress">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge $textAlign="left">Confirm your mailing address</TitleLarge>
          </HeadingContainer>
          <FormContainer>
            <Autocomplete
              value={mailingAddress?.addressLine1 || ""}
              name="mailing-address-line1"
              title="Current address line 1*"
              onLoadOptions={onLoadAddress}
              onChange={(e) => {
                if (!e) {
                  setMailingAddress({ ...mailingAddress, addressLine1: "" });
                  return;
                }
                try {
                  const addObj = JSON.parse(e.value);
                  updateAutofillAddress(addObj);
                } catch {
                  setMailingAddress({ ...mailingAddress, addressLine1: e.value });
                }
              }}
              onBlur={() => validateField("addressLine1")}
              errorText={(validation?.addressLine1 as string) || undefined}
              size="large"
            />
            <TextField
              value={mailingAddress?.addressLine2 || ""}
              name="mailing-address-line2"
              title="Apartment, suite, etc."
              size="large"
              onChange={(e) => setMailingAddress({ ...mailingAddress, addressLine2: e.target.value })}
            />
            <TextField
              value={mailingAddress?.city || ""}
              name="mailing-address-city"
              title="City*"
              onChange={(e) => setMailingAddress({ ...mailingAddress, city: e.target.value })}
              onBlur={() => validateField("city")}
              errorText={(validation?.city as string) || undefined}
              isError={Boolean(validation?.city)}
              size="large"
            />
            <SearchableDropdown
              options={statesList}
              onChange={(e) => setMailingAddress({ ...mailingAddress, state: e?.value || "" })}
              name="mailing-address-states"
              title="State*"
              value={mailingAddress?.state}
              errorText={(validation?.state as string) || undefined}
              size="large"
            />
            <TextField
              value={mailingAddress?.zipCode}
              name="mailing-address-zipcode"
              title="Zip code"
              onChange={(e) => setMailingAddress({ ...mailingAddress, zipCode: e.target.value })}
              onBlur={() => validateField("zipCode")}
              errorText={(validation?.zipCode as string) || undefined}
              isError={Boolean(validation?.zipCode)}
              inputMode="numeric"
              size="large"
            />
          </FormContainer>
          <Spacing vertical="16" />
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={onClickContinue} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default MailingAddress;
